import dynamic from 'next/dynamic'

export const MapComponentNoSSR = dynamic(() => import('./MapComponent'), {
  ssr: false,
  loading: () => <></>,
})
